var map = {
	"./Blog/habitat-async.js": "khLK",
	"./ExampleComponent/habitat-async.js": "8egD",
	"./LocationsMap/habitat-async.js": "A9/e",
	"./Testimonials/habitat-async.js": "1gJz"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "lUg7";